<template>
    <div class="flex bg-[rgba(93,93,152,0.55)] rounded-md gap-2 p-1">
        <appButton v-for="filter in visibleFilters" :key="filter.filter_name"
            :text="filter.filter_name"
            :color="filter.filter_selected ? selected_color : normal_color" 
            emitType="select"
            @select="select_OnClick(filter)"
            right_icon="fa-solid fa-x"
            @close="close_OnClick(filter)"
        />
        <div >
            <AppFilterList :filter_data="filter_data"/>
        </div>
    </div>
</template>

<script>
    import AppButton from './filterbutton.vue'
    import AppFilterList from './filterList.vue'
    import '@fortawesome/fontawesome-free/css/all.css'
    
    export default {
        name:'AppFilter',
        components:{
            AppButton,
            AppFilterList,
        },
        props: {
            filter_data:{
                type: Array,
                default: () =>[]
            },
        },
        emits:['filter-selected','filter-closed', 'list-clicked' ],
        methods:{
            select_OnClick(filter){
                console.log("filter selected:", filter)
                this.$emit('filter-selected', filter)
                filter.filter_selected=true;
                this.unselect_filter(this.filter_data, filter.filter_name)
            },
            close_OnClick(filter){
                console.log("filter to close:", filter)
                this.$emit('filter-closed', filter)
                filter.filter_visibility = false;
            },
            list_OnClick(){
                console.log("list clicked")
                this.$emit("list-clicked")
            },
            unselect_filter(filters, filter_name) {
                for (let i = 0; i < filters.length; i++) { // Fixed loop condition
                    if (filters[i].filter_name !== filter_name) {
                        filters[i].filter_selected = false;
                    }
                }
            }
        },
        data() {
            return {
                selected_color:'#B2B2D8',
                normal_color:'rgba(93, 93, 152, 0.55)',
            }
        },
        computed: {
            visibleFilters() {
                return this.filter_data.filter(filter => filter.filter_visibility);
            }
        }
    }
</script>

<style>
    .filter_container{
        width: 66.188rem;
        border-radius: 0.5rem;
        display: flex;
        gap: 1rem;
        background-color:rgb(77, 77, 108,0.45);
    }
    /* .list_container{
        margin-left: auto;
        padding-right: 1rem;
        height: 3.063rem;
        display: flex;
        justify-content: center;
        align-items: center;
    } */
</style>

